import { gql, TypedDocumentNode } from '@common/hooks';
import {
  SaveWorkerProfileChangeMutationCgResponse,
  SaveWorkerProfileChangeMutationVariables,
} from '@common/graphql';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

export const SAVE_WORKER_PROFILE_CHANGE_MUTATION: TypedDocumentNode<
  SaveWorkerProfileChangeMutationCgResponse,
  SaveWorkerProfileChangeMutationVariables
> = gql`
  mutation SaveWorkerProfileChange(
    $workerId: ID!
    $scheduleGroupId: ID!
    $termId: ID
    $effectiveStartDate: ISO8601Date
    $effectiveEndDate: ISO8601Date
    $accountActive: Boolean!
    $role: String!
    $ftePercentage: Float
    $chargeEligible: Boolean!
    $preferredTime: LoadBalancingScheduleShiftPreference!
    $shiftPatternPreference: LoadBalancingShiftPatternPreference!
    $schedulingPeriodId: ID
    $skillUuids: [ID!]
  ) {
    saveWorkerProfileChange(
      workerId: $workerId
      serviceLineId: $scheduleGroupId
      termId: $termId
      effectiveStartDate: $effectiveStartDate
      effectiveEndDate: $effectiveEndDate
      accountActive: $accountActive
      role: $role
      ftePercentage: $ftePercentage
      chargeEligible: $chargeEligible
      preferredTime: $preferredTime
      shiftPatternPreference: $shiftPatternPreference
      schedulingPeriodId: $schedulingPeriodId
      skillUuids: $skillUuids
    ) {
      termId
      worker {
        id
        name
        terms {
          id
          active
          effectiveStartDate
          effectiveEndDate
          employmentType
          role
          homeUnit
          fteHours
          ftePercentage
          preferredTime
          shiftPatternPreference
          chargeEligible
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
